import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import createaction from "../../context/action/unit/createaction";
import Unitlist from "./unitlist";

const Unit = () => {
    const { recaller, setrecaller, initDispatch, clear } =
        useContext(GlobalContext);
    
    const [unit_name, setunit_name] = useState();
    const [error, seterror] = useState(false);
    return (
        <div className="min-h-screen bg-slate-50 p-6 md:p-8">
            {/* Page Header */}
            <div className="flex items-center justify-between mb-8">
                <div>
                    <h1 className="text-2xl font-bold text-slate-800">یەکەکان</h1>
                    <p className="text-sm text-slate-400 mt-0.5">بەڕێوەبردنی یەکەکان</p>
                </div>
            </div>

            {/* Add New Unit Form */}
            <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 items-end">
                <div className="w-full">
                    <label
                    className={
                        error
                        ? "block text-sm font-medium text-red-500 mb-1 text-right"
                        : "block text-sm font-medium text-slate-500 mb-1 text-right"
                    }
                    htmlFor="unit_name"
                    >
                    ناوی یەکە
                    </label>
                    <input
                    className={
                        error
                        ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                        : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                    }
                    id="unit_name"
                    type="text"
                    placeholder=""
                    onClick={(val)=>{val.target.select()}}
                    value={unit_name}
                    onChange={(val) => setunit_name(val.target.value)}
                    onFocus={() => seterror(false)}
                    />
                </div>
                <div className="w-full">
                    <button
                    className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
                    onClick={() => {
                        if (unit_name == "" || !unit_name) {
                        seterror(true);
                        return false;
                        }
                        createaction(unit_name)(recaller)(setrecaller)(initDispatch)(
                        clear
                        );
                    }}
                    >
                    زیادکردن
                    </button>
                </div>
            </div>
            </div>

            {/* Unit List Section */}
            <Unitlist />
        </div>
    )
}

export default Unit